
import './App.css';
import Header from './Header';
import HomePage from './Home';
import Footer from './Footer';
import AboutUs from './AboutUs'; // 👈 import AboutUs page
import Vacancies from './Vacancies';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        
        {/* 👇 Routes will decide which page to show */}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/vacancies" element={<Vacancies />} />
        </Routes>
        
        <Footer />
      </div>
    </Router>
  );
}

export default App;

